import React from 'react';
import { motion } from 'framer-motion';
const pains = [{
  emoji: '😰',
  title: 'Trabajás mucho, pero no ves la plata clara',
  desc: 'Atendés, respondés, comprás insumos, organizás turnos y terminás agotada, sin tener del todo claro cuánto te queda realmente.'
}, {
  emoji: '📱',
  title: 'WhatsApp te consume tiempo y no siempre vende',
  desc: 'Respondés consultas todo el día, pasás precios, explicás condiciones y muchas veces eso no termina en una reserva real.'
}, {
  emoji: '💸',
  title: 'Te cuesta poner precios con seguridad',
  desc: 'No sabés si estás cobrando bien, si estás perdiendo plata con tus costos o si estás trabajando de más para ganar menos.'
}, {
  emoji: '🌀',
  title: 'Todo depende de tu cabeza y tu esfuerzo diario',
  desc: 'No tenés un sistema claro para ordenar clientas, seguimiento, políticas, comunicación y operación. Si vos no sostenés todo, todo se desordena.'
}];
export function PainPoints() {
  return <section className="py-20 bg-white" data-id="element-166">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-169">
            ¿Te reconocés en esto?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-170">
            Sos buena haciendo pestañas, pero sentís que tu negocio depende
            demasiado de vos, de tu energía y de resolver todo sobre la marcha.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-171">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-ocean-cream p-8 rounded-3xl border border-gray-100 shadow-sm hover:shadow-soft transition-shadow" data-id="element-172">
              <div className="text-4xl mb-4" aria-hidden="true" data-id="element-173">
                {pain.emoji}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-174">
                {pain.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-175">{pain.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}